import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  Box,
  Tabs,
  Tab,
  Paper,
  Alert
} from '@mui/material';
import VersionsTable from '../components/updates/VersionsTable';
import DevicesStatusTable from '../components/updates/DevicesStatusTable';
import AddVersionModal from '../components/updates/AddVersionModal';
import UpdateSettingsPanel from '../components/updates/UpdateSettingsPanel';
import UpdateGuidePanel from '../components/updates/UpdateGuidePanel';
import { getAllUpdates } from '../services/deviceAppUpdateService';

function TabPanel({ children, value, index }) {
  return (
    <div hidden={value !== index}>
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
}

export default function DeviceAppUpdatesPage() {
  const [tabValue, setTabValue] = useState(0);
  const [updates, setUpdates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [editingVersion, setEditingVersion] = useState(null);

  useEffect(() => {
    loadUpdates();
  }, []);

  const loadUpdates = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await getAllUpdates();
      setUpdates(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleAddSuccess = () => {
    setAddModalOpen(false);
    setEditingVersion(null);
    loadUpdates();
  };

  const handleEditVersion = (version) => {
    setEditingVersion(version);
    setAddModalOpen(true);
  };

  return (
    <Container maxWidth="xl">
      <Box sx={{ mt: 4, mb: 4 }}>
        {/* Header */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Typography variant="h4" component="h1">
            📦 Aggiornamenti App Kiosk
          </Typography>
        </Box>

        {/* Error Alert */}
        {error && (
          <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError(null)}>
            {error}
          </Alert>
        )}

        {/* Tabs */}
        <Paper sx={{ mb: 2 }}>
          <Tabs value={tabValue} onChange={handleTabChange}>
            <Tab label="Versioni" />
            <Tab label="Stato Distribuzione" />
            <Tab label="Configurazioni" />
            <Tab label="📖 Guida" />
          </Tabs>
        </Paper>

        {/* Tab Panels */}
        <TabPanel value={tabValue} index={0}>
          <VersionsTable
            updates={updates}
            loading={loading}
            onRefresh={loadUpdates}
            onAddVersion={() => setAddModalOpen(true)}
            onEditVersion={handleEditVersion}
          />
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <DevicesStatusTable />
        </TabPanel>

        <TabPanel value={tabValue} index={2}>
          <UpdateSettingsPanel />
        </TabPanel>

        <TabPanel value={tabValue} index={3}>
          <UpdateGuidePanel />
        </TabPanel>

        {/* Add/Edit Version Modal */}
        <AddVersionModal
          open={addModalOpen}
          onClose={() => {
            setAddModalOpen(false);
            setEditingVersion(null);
          }}
          onSuccess={handleAddSuccess}
          editingVersion={editingVersion}
        />
      </Box>
    </Container>
  );
}
